import React, { useState } from 'react';
import OrderTransactionDto from '../../Common/dtos/OrderTransactionDto';
import { Col, Row } from 'reactstrap';
import BoldButton from '../../Common/BoldButton';
import { CenteredSpinner } from '../../Common/CenteredSpinner';
import useDisplayMessage from '../../Common/useDisplayMessage';
import KaAlert from '../../Common/KaAlert';
import useGetTicketImage from '../../../requests/useGetTicketImage';
import { useFileDownload } from '../../Common/useFileDownload';

interface TicketImageViewProps {
  orderTransaction: OrderTransactionDto,
  backClicked: () => void
}

const TicketImageView = ({ orderTransaction, backClicked } : TicketImageViewProps) => {
  const displayMessage = useDisplayMessage();
  const [imageUri, setImageUri] = useState<string>();
  const [imageFileUrl, setImageFileUrl] = useState<string>('');

  const getTicketImage = useGetTicketImage(orderTransaction.id, {
    onSuccess: (resp) => {
      setImageUri(resp.ticketImageUri);
      fetch(resp.ticketImageUri)
        .then(res => res.blob())
        .then(blob =>
          setImageFileUrl(window.URL.createObjectURL(blob))
        );
    },
    onError: () => {
      displayMessage.fail(`No ticket image found for order transaction ${orderTransaction.number}.`)
    },
  });

  const downloadTicketImage = useFileDownload(imageFileUrl, `${orderTransaction.siteName}-Ticket${orderTransaction.number}.jpg`);

  return <>
    <Row className="justify-content-between mb-2">
      <Col>
        <BoldButton className="col-auto btn-ghost-secondary" variant="link" onClick={backClicked}>
          <i className="bi-chevron-left" /> Back
        </BoldButton>
      </Col>
      {getTicketImage.isSuccess && <Col className="ps-0 pe-3 text-end">
        <button className="btn py-0 px-3" onClick={downloadTicketImage} data-testid="download">
          <i className="bi bi-cloud-download ka-blue" style={{ fontSize: "2em" }} />
        </button>
      </Col>}
    </Row>
    <KaAlert displayMessage={displayMessage.message} onClose={displayMessage.clear} />
    <Row className="mx-5">
      {getTicketImage.isLoading && <CenteredSpinner />}
      {getTicketImage.isSuccess && <img src={imageUri} alt="" />}
    </Row>
  </>
}

export default TicketImageView;
